import { render, staticRenderFns } from "./tagshow.vue?vue&type=template&id=0f93026a&scoped=true"
import script from "./tagshow.vue?vue&type=script&lang=js"
export * from "./tagshow.vue?vue&type=script&lang=js"
import style0 from "./tagshow.vue?vue&type=style&index=0&id=0f93026a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f93026a",
  null
  
)

export default component.exports